import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { FileText, Pencil, Satellite } from "lucide-react";

interface MeasurementOptionsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onManualEntry: () => void;
  onImportPDF: () => void;
  onGoogleSolar: () => void;
  showSolarOption?: boolean;
}

export function MeasurementOptionsDialog({
  open,
  onOpenChange,
  onManualEntry,
  onImportPDF,
  onGoogleSolar,
  showSolarOption = false,
}: MeasurementOptionsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Choose Measurement Method</DialogTitle>
          <DialogDescription>
            Select how you'd like to add measurements for this trade
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-3 py-4">
          <Button
            variant="outline"
            className="w-full justify-start h-auto py-4"
            onClick={() => {
              onOpenChange(false);
              onManualEntry();
            }}
          >
            <Pencil className="mr-3 h-5 w-5" />
            <div className="text-left">
              <div className="font-semibold">Manual Entry</div>
              <div className="text-xs text-muted-foreground">Enter measurements manually</div>
            </div>
          </Button>

          <Button
            variant="outline"
            className="w-full justify-start h-auto py-4"
            onClick={() => {
              onOpenChange(false);
              onImportPDF();
            }}
          >
            <FileText className="mr-3 h-5 w-5" />
            <div className="text-left">
              <div className="font-semibold">Import PDF</div>
              <div className="text-xs text-muted-foreground">Upload report from Hover, GAF, Roofr</div>
            </div>
          </Button>

          {showSolarOption && (
            <Button
              variant="outline"
              className="w-full justify-start h-auto py-4 border-primary/50 bg-primary/5"
              onClick={() => {
                onOpenChange(false);
                onGoogleSolar();
              }}
            >
              <Satellite className="mr-3 h-5 w-5 text-primary" />
              <div className="text-left">
                <div className="font-semibold">Google Solar API</div>
                <div className="text-xs text-muted-foreground">Instant satellite measurements (most accurate)</div>
              </div>
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
